import React from "react";

const CustomSnackbarDispatchContext = React.createContext();
const CustomSnackbarDispatchProvider = CustomSnackbarDispatchContext.Provider;

export { CustomSnackbarDispatchContext, CustomSnackbarDispatchProvider };
